<!-- pass in theme to get desired button color, size for the padding top and bottom, radius for border radius.

to get desired button width, in the file where you are using the button wrap the button component in a div and apply a width to that wrapper div eg <div classname="w-[10%]"><buttonComponent/></div>

for the button text and to create variations with and without icons the components uses slots

example of what the button component might look like in your file:

<Button 
:theme="'danger'"
:size="'large'" 
:radius="'medium'"
@handleClick="testClick"
  >
      <img src="@/assets/svg/arrow-left.svg" />
      <p class="text-white font-medium text-[16px]">Go to Dashboard</p>

    </Button>

-->

<template>
  <!-- @click="$emit('handleClick')" -->
  <button
    type="buttonType"
    class="flex items-center justify-center w-full gap-2 px-2 disabled:cursor-not-allowed"
    :class="[
      computedTheme,
      computedSize,
      computedRadius,
      buttonWidth,
      `${disabled ? 'opacity-50' : 'opacity-100'}`,
    ]"
    :disabled="disabled"
    @click="handleClick"
  >
    <slot></slot>
  </button>
</template>

<script>
export default {
  props: {
    theme: {
      type: String,
      required: false,
      default: "",
    },
    size: {
      type: String,
      required: false,
      default: "",
    },
    buttonWidth: {
      type: String,
      required: false,
    },
    radius: {
      type: String,
      required: false,
      default: "small",
    },
    disabled: {
      type: Boolean,
      required: false,
    },
    buttonType: {
      type: String,
      required: false,
      default: "button",
    },

    eventName: String,
    eventCategory: String,
    eventLabel: String,
  },
  data() {
    return {};
  },

  computed: {
    computedTheme() {
      const themes = {
        positiveOutline:
          "border border-estationsGreen-500 bg-white text-estationsGreen-500",
        greyOutline: "border border-gray-300 bg-gray-50 text-gray-700",
        yellowOutline: "border border-yellow-500 text-yellow-600",
        danger: "bg-[#D44333] text-white",
        dangerLight: "bg-[#FDF0EF] text-[#D44333]",
        dangerOutline: "border border-red-400 text-red-500",
        positiveLight: "bg-estationsGreen-50 text-estationsGreen-700",
        positiveSolid: "bg-estationsGreen-500 text-white",
        positiveGhost: "bg-transparent text-estationsGreen-500",
        blackSolid: "bg-[#000000] text-white",
        blackPositiveOutline:
          "bg-[#000000] border border-estationsGreen-500 text-white",
        blackOutline: "border border-black text-black",
        inactiveGrey: "border bg-gray-400 text-gray-600",
      };
      return themes[this.theme] || themes.blackSolid;
    },
    computedSize() {
      const sizes = {
        large: "py-[20px] text-lg",
        medium: "py-[10px] text-base",
        small: "py-2 text-sm",
        extraSmall: "py-1 text-xs",
      };
      return sizes[this.size] || sizes.medium;
    },
    computedRadius() {
      const radii = {
        large: "rounded-[50px]",
        medium: "rounded-[10px]",
        small: "rounded-[8px]",
      };
      return radii[this.radius] || radii.small;
    },
  },

  methods: {
    handleClick() {
      // GA4 CUSTOM BUTTON EVENT TRACKER
      if (this.eventName && window.gtag) {
        window.gtag("event", this.eventName, {
          event_category: this.eventCategory || "button",
          event_label:
            this.eventLabel || this.$slots.default?.[0]?.children || "Button",
        });
      }
      this.$emit("handleClick");
    },
  },
};
</script>

<style></style>
